<template>
  <div class="about-us">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ title }}</span>
      <span></span>
    </header>
    <main class="page-body">
      <van-cell-group>
        <div class="van-cell  van-field">
          <div class="van-cell__title van-field__label">
            <span>{{ $t('发货线路') }}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <select
                class="van-field__control"
                v-model="form.lineId"
                @change="onChange"
              >
                <option
                  v-for="(item, index) in lineList"
                  :key="index"
                  :value="item.PK_ID"
                  >[{{ item.sCode }}] {{ item.sName }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="van-cell  van-field">
          <div class="van-cell__title van-field__label">
            <span>{{ $t('业务模式') }}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <select
                class="van-field__control"
                v-model="form.bizType"
                @change="onChange"
              >
                <option
                  v-for="(item, index) in bizList"
                  :key="index"
                  :value="item.PK_ID"
                  >[{{ item.sCode }}]{{ item.sName }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="van-cell  van-field">
          <div class="van-cell__title van-field__label">
            <span>{{ $t('货物类型') }}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <select
                class="van-field__control"
                v-model="form.senseType"
                @change="onChange"
              >
                <option
                  v-for="(item, index) in senseList"
                  :key="index"
                  :value="item.PK_ID"
                  >[{{ item.sCode }}]{{ item.sName }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="van-cell  van-field">
          <div class="van-cell__title van-field__label">
            <span>{{ $t('会员等级') }}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <select
                class="van-field__control"
                v-model="form.memberLevel"
                @change="onChange"
              >
                <option
                  v-for="(item, index) in memberList"
                  :key="index"
                  :value="item.PK_ID"
                  >{{ item.name }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="van-cell  van-field">
          <div class="van-cell__title van-field__label">
            <span>{{ $t('计费方式') }}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <select class="van-field__control" v-model="form.barginType">
                <option
                  v-for="(item, index) in barginList"
                  :key="index"
                  :value="item.PK_ID"
                  >[{{ item.sCode }}]{{ item.sName }}{{ item.sKey }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <van-field
          v-model="originalVal"
          :label="$t('体积/重量')"
          type="number"
          @change="onChange"
          :placeholder="$t('请输入体积/重量')"
          :border="true"
        />
        <van-cell :title="$t('预估运费')" :value="output" />

        <van-row>
          <van-col span="24">
            <van-button type="info" block @click="onChange">{{
              $t('计算')
            }}</van-button></van-col
          >
        </van-row>
      </van-cell-group>

      <van-cell-group
        class="price-step-item"
        v-for="item in priceStraList"
        v-bind:key="item.PK_ID"
        :title="
          '[' +
            item.lineChannelName +
            '/' +
            item.lineCode +
            ']' +
            item.lineName +
            '  ' +
            item.senseTypeName
        "
      >
        <van-cell
          title="始发地/目的地"
          :value="item.startPlace + '-' + item.endPlace"
        />
        <van-cell
          title="计费方式"
          :value="item.barginTypeName + ' ' + item.barginUnitName"
        />
        <van-cell title="会员等级" :value="item.memberLevelName" />
        <van-cell
          v-if="item.bStepMode == false"
          title="价格"
          :value="item.fFirstPrice"
        />
        <van-cell v-if="item.sRemark" title="说明" :label="item.sRemark" />
        <div
          class="price-step"
          v-if="item.StepList != null && item.StepList.length > 0"
        >
          <van-row style="text-align: center;">
            <van-col span="8">阶梯</van-col>
            <van-col span="4">计价方式</van-col>
            <van-col span="4">阶梯价</van-col>
            <van-col span="8">备注</van-col>
          </van-row>
          <van-row v-for="it in item.StepList" v-bind:key="it.PK_ID">
            <van-col span="8">
              {{ item.barginTypeName }} <span>&lt;=</span> {{ it.fCeilVolWei }}
              {{ item.barginUnitName }}</van-col
            >
            <van-col span="4">{{ barginTypeDict[it.iBarginType] }}</van-col>
            <van-col span="4">{{ it.fPrice }}</van-col>
            <van-col span="8">{{ it.sRemark }}</van-col>
          </van-row>
        </div>
      </van-cell-group>
    </main>
  </div>
</template>
<script>
import {
  getCommonConfList,
  getOrgInfoByUrl,
  getPriceStaList,
  getActualPriceFee,
} from '@/api/website.js';
import { $t } from '@/plugins/i18n';
import Clipboard from 'clipboard';

export default {
  data() {
    return {
      title: $t('运费估算'),
      orgInfo: {},
      form: {
        lineId: 0,
        memberLevel: 0,
        bizType: 0,
        senseType: 0,
        barginType: 0,
      },
      originalVal: 0,
      output: 0,
      lineList: [],
      memberList: [],
      bizList: [],
      senseList: [],
      barginList: [],
      priceStraList: [],
      loading: false,
      barginTypeDict: {
        0: '按重量',
        1: '按体积',
        2: '体积重',
        3: '密度',
        4: '积载体积',
      },
      lastPriceData: null,
    };
  },
  async mounted() {
    let jsInfo = localStorage.getItem('ORG_INFO');
    if (jsInfo != null) {
      this.orgInfo = JSON.parse(jsInfo);
    } else {
      await getOrgInfoByUrl(window.location.href).then(res => {
        console.log(res);
        if (res.Result == true) {
          this.orgInfo = res.DataDict['org'];
          localStorage.setItem('ORG_INFO', JSON.stringify(this.orgInfo));
        }
      });
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      let that = this;
      getCommonConfList(this.orgInfo.PK_ID)
        .then(res => {
          console.log(res);
          if (res.Result == true) {
            this.lineList = res.DataDict['line'];
            if (this.lineList.length > 0) {
              this.form.lineId = this.lineList[0].PK_ID;
            }
            this.memberList = res.DataDict['memberType'];
            if (this.memberList.length > 0) {
              this.form.memberLevel = this.memberList[0].PK_ID;
            }
            this.bizList = res.DataDict['bizType'];
            if (this.bizList.length > 0) {
              this.form.bizType = this.bizList[0].PK_ID;
            }
            this.senseList = res.DataDict['senseType'];
            if (this.senseList.length > 0) {
              this.form.senseType = this.senseList[0].PK_ID;
            }
            this.barginList = res.DataDict['barginType'];
            if (this.barginList.length > 0) {
              this.form.barginType = this.barginList[0].PK_ID;
            }
            that.onChange();
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    onChange() {
      getPriceStaList({
        lineId: this.form.lineId,
        memberTypeId: this.form.memberLevel,
        bizTypeId: this.form.bizType,
        senseTypeId: this.form.senseType,
      }).then(res => {
        console.log(res);
        if (res.Result == true) {
          this.priceStraList = res.DataDict['list'];
          if (this.priceStraList.length > 0) {
            this.lastPriceData = this.priceStraList[0];
            getActualPriceFee({
              strategyId: this.lastPriceData.PK_ID,
              priceVol: this.originalVal,
              priceWeight: this.originalVal,
              weiVol: this.originalVal,
            }).then(res => {
              console.log(res);
              if (res.Result == true) {
                this.output = `${res.DataDict['data'].CurrencyName}: ${res.DataDict['data'].TotalAmount} ${res.DataDict['data'].CurrencyCode}`;
              } else {
                this.output = '';
                this.$toast.fail(res.Info);
              }
            });
          } else {
            this.output = '';
            this.$toast.fail(res.Info);
            this.lastPriceData = null;
            this.priceStraList = [];
          }
        } else {
          this.output = '';
          this.$toast.fail(res.Info);
          this.lastPriceData = null;
          this.priceStraList = [];
        }
      });
    },

    copy() {
      let _this = this;
      let clipborad = new Clipboard('#copy');
      //复制成功
      clipborad.on('success', function() {
        _this.$toast.success($t('复制成功！'));
        clipborad.destory();
      });
      //复制失败
      clipborad.on('error', function() {
        _this.$toast.fail($t('复制失败！'));
        clipborad.destory();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';

.banner {
  height: rem(240px);
  margin-bottom: rem(40px);
  background-color: $theme-color;
  background-size: cover;
}
.page-body {
  padding: rem(40px);
  background: #fff;
  .group-title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 3px;
  }
  .price-step {
    margin-left: 15px;
    margin-right: 15px;
    text-align: center;
  }
  .price-step-item {
    border: 1px solid #efefef;
    border-radius: 5px;
    margin-bottom: 10px;
  }
}
h1 {
  font-size: 16px;
}
h2 {
  font-size: 12px;
  color: #b8b8b8;
}
p {
  line-height: 1.5;
}
</style>
